import { __awaiter, __generator } from "tslib";
import { Lock } from "./Lock";
import { ERR_INVALID_ARGUMENT } from "../error";
/**
 * The TaskQueue is a FIFO queue for asynchronous tasks. The tasks are sequentially processed
 * in the order they were added.
 */
var TaskQueue = /** @class */ (function () {
    function TaskQueue(pLock) {
        this.mLock = pLock != null ? pLock : new Lock();
    }
    Object.defineProperty(TaskQueue.prototype, "hasPendingTasks", {
        get: function () {
            return (this.mLock.isLocked);
        },
        enumerable: false,
        configurable: true
    });
    TaskQueue.prototype.addTask = function (pTask) {
        return __awaiter(this, void 0, void 0, function () {
            var tLockContext, tResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (pTask == null)
                            return [2 /*return*/, (Promise.reject(new Error(ERR_INVALID_ARGUMENT)))];
                        return [4 /*yield*/, this.mLock.acquireLock()];
                    case 1:
                        tLockContext = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, , 4, 5]);
                        return [4 /*yield*/, pTask()];
                    case 3:
                        tResult = _a.sent();
                        return [2 /*return*/, (tResult)];
                    case 4:
                        //delay unlock to make sure that the promise then chain was executed first
                        tLockContext.unlock(true);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return TaskQueue;
}());
export { TaskQueue };
export default TaskQueue;
